import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import "datatables.net-bs4";
import { UserContext } from "../../App";
import { deleteFolder, useFolders } from "../../utils/folder";
import ActionsMenu from "../layout/ActionsMenu";
import { useTarifsOptions } from "../../utils/estimate-invoice";
import { estimateStatus } from "./estimateContent";
import { invoiceStatus } from "./invoiceContent";
import { verifyRight } from "../../utils/users";
import SelectionActionsPopup from "../layout/SelectionActionsPopup";
import TrashIcon from "../icons/TrashIcon";
import { StyledTr } from "./bookingContent";
import { OutlineButtonLink } from "../layout/OutlineButton";

export default function FolderContent() {
  const { userInfos } = useContext(UserContext);
  const [checked, setChecked] = useState([]);
  const { folders, loaded } = useFolders();
  const datatable = useRef(null);
  const tarifsOptions = useTarifsOptions();

  useEffect(() => {
    if (datatable.current) {
      datatable.current.destroy();
      datatable.current = null;
    }

    window.setTimeout(() => {
      datatable.current = $("#datatable").DataTable({
        retrieve: true,
        order: [[1, "asc"]],
        pageLength: 25,
      });
    }, 1);
  }, [folders, loaded]);

  function handleCheckbox(e) {
    const { value, checked: isChecked } = e.target;

    if (isChecked) {
      setChecked((old) => [...old, value]);
    } else {
      setChecked((old) => old.filter((id) => id !== value));
    }
  }

  const datatableContent = useMemo(() => {
    return (
      <tbody>
        {folders.map((folder, index) => {
          const actions = [];
          if (verifyRight(userInfos, "folder", "update"))
            actions.push({
              label: "Modifier",
              link: "/folders/" + folder.id,
            });

          if (verifyRight(userInfos, "booking", "read"))
            actions.push({
              label: "Voir les courses",
              link: "/?folder_id=" + folder.id,
            });

          const tarifLabel = tarifsOptions.find(
            (tarif) => tarif.value === folder.tarif
          )?.label;

          return (
            <StyledTr
              className={checked.includes(folder.id) ? "checked" : ""}
              key={folder.id}
            >
              <td style={{ textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={checked.includes(folder.id)}
                  name="bulk_action"
                  value={folder.id}
                  onChange={handleCheckbox}
                />
              </td>
              <td>{index + 1}</td>
              <td>
                <a href={`/?folder_id=${folder.id}`}>{folder.id}</a>
              </td>
              <td>{folder.name || "N/A"}</td>
              <td>{folder?.provider?.name || "N/A"}</td>
              <td>{folder?.contact?.name || "N/A"}</td>
              <td>{folder?.contact?.phone || "N/A"}</td>
              <td>{folder?.contact?.email || "N/A"}</td>
              <td>{folder?.contact?.role || "N/A"}</td>
              <td>{tarifLabel || "N/A"}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                {folder.estimate_id && (
                  <>
                    <Link
                      to={`/estimates/${folder.estimate_id}`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Devis n°{folder.estimate_id}
                    </Link>{" "}
                    ({estimateStatus[folder.estimate_status]})
                  </>
                )}
                <br />
                {folder.invoice_id && (
                  <>
                    <Link
                      to={`/invoices/${folder.invoice_id}`}
                      style={{ whiteSpace: "nowrap" }}
                    >
                      Facture n°{folder.invoice_id}
                    </Link>{" "}
                    ({invoiceStatus[folder.invoice_status]})
                  </>
                )}
              </td>
              <td>
                <ActionsMenu items={actions} />
              </td>
            </StyledTr>
          );
        })}
      </tbody>
    );
  }, [folders, userInfos, tarifsOptions, checked]);

  const handleDeleteFolder = useCallback(async () => {
    if (checked.length) {
      if (!window.confirm("Voulez-vous vraiment supprimer ce(s) dossier(s) ?"))
        return;
      await deleteFolder(userInfos, checked);
      window.location.reload();
    }
  }, [checked, userInfos]);

  const PortletFooter = useMemo(() => {
    if (checked.length) {
      let buttons = [];
      if (verifyRight(userInfos, "folder", "delete"))
        buttons.push({
          label: <TrashIcon />,
          title: "Supprimer",
          onClick: handleDeleteFolder,
        });

      return (
        <SelectionActionsPopup
          selectedItemsLength={checked.length}
          resetChecked={() => setChecked([])}
          buttons={buttons}
          items={[]}
        />
      );
    }
  }, [checked.length, handleDeleteFolder, userInfos]);

  if (!loaded) {
    return (
      <div className="kt-content kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
          <div className="">
            <div className="kt-portlet__body">
              <div className="text-center">Chargement...</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="body-container">
      <div className="title-container">
        <h3 className="title">Dossiers</h3>
        <div className="header-toolbar">
          {verifyRight(userInfos, "folder", "create") && (
            <OutlineButtonLink to="/addFolder/">
              <i className="la la-plus"></i>
              Nouveau dossier
            </OutlineButtonLink>
          )}
        </div>
      </div>

      <div>
        <div className="kt-portlet--mobile">
          <div className="kt-portlet__body" style={{ overflowX: "scroll" }}>
            <table
              className="table table-striped- table-bordered table-hover table-checkable"
              id="datatable"
            >
              <thead>
                <tr>
                  <th
                    style={{ width: "5%", textAlign: "center" }}
                    data-sort="false"
                  >
                    Selection
                  </th>
                  <th style={{ width: "5%" }}>#</th>
                  <th style={{ width: "30%" }}>ID</th>
                  <th style={{ width: "30%" }}>Nom</th>
                  <th style={{ width: "20%" }}>Client</th>
                  <th style={{ width: "20%" }}>Nom Contact</th>
                  <th style={{ width: "30%" }}>Tél Contact</th>
                  <th style={{ width: "30%" }}>Email Contact</th>
                  <th style={{ width: "30%" }}>Fonction Contact</th>
                  <th style={{ width: "30%" }}>Tarif</th>
                  <th style={{ width: "30%" }}>Statut</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              {datatableContent}
            </table>
          </div>
          {PortletFooter}
        </div>
      </div>
    </div>
  );
}
